<template>
  <li
    v-if="canViewHorizontalNavMenuLink(item)"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="dropdown-item"
    >
      <feather-icon
        :icon="item.icon || 'CircleIcon'"
        size="24"
      />
      <span class="menu-title">{{ t(item.title) }}</span>
      <b-badge
        v-if="hasStatistics(item.route).show"
        pill
        variant="secondary"
        class="ml-1"
      >
        {{ hasStatistics(item.route).badge }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { BBadge, BLink } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import useHorizontalNavMenuLink from './useHorizontalNavMenuLink'
import mixinHorizontalNavMenuLink from './mixinHorizontalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinHorizontalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
    statistics: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  methods: {
    hasStatistics(route) {
      if (route === 'app-invoices' || route === 'app-schedule') {
        return { show: this.statistics.invoices > 0, badge: this.statistics.invoices }
      }

      if (route === 'app-order') {
        return { show: this.statistics.jobs > 0, badge: this.statistics.jobs }
      }

      return { show: false }
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useHorizontalNavMenuLink(props.item)

    const { t } = useI18nUtils()
    const { canViewHorizontalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,
      canViewHorizontalNavMenuLink,
      t,
    }
  },
}
</script>
